import { attach } from "../../common/componentExtensions";
import AttachmentsStore from "../attachmentsPreviewStore";
import AttachmentsActions from "../attachmentsActions";
import React from "react";
import OpenModalLink from "../../common/components/openModalLink";

const AttachmentPreview: React.FunctionComponent<{ fileKey: string, imageString: string | null, loading: boolean, width?: number, height?: number, className?: string }> = ({ fileKey, imageString, className, loading, width, height }) => {
    React.useEffect(() => {
        if (!imageString) {
            AttachmentsActions.preview(fileKey);
        }
    });

    if (loading)
        return <div className="d-flex justify-content-center align-items-center"
            style={{ width: width || "100%", height: height || "100%" }}>
            <i className="fas fa-spinner fa-pulse"></i>
        </div>

    return (
        <OpenModalLink
            modalContent={
                <div className="w-100 h-100 d-flex justify-content-center">
                    <img
                        src={`data:image/png;base64,${imageString}`}
                        className="img-fluid"
                    />
                </div>}
            header="Anteprima immagine"
            forceReload
            style={{ cursor: "zoom-in", display: "block" }}>
            <img
                className={className}
                src={`data:image/png;base64,${imageString}`}
                width={width}
                height={height}
            />
        </OpenModalLink>
    );
}

export default attach(AttachmentPreview, AttachmentsStore, (store, props) => {
    let imageString = store.get(props.fileKey)?.stringImage || null;
    return {
        imageString,
        loading: imageString == null,
    }
})